/*
 * @Author: liyxt
 * @Date: 2020-05-28 14:28:27
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-04 14:28:57
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginAlert from 'bee-alert';
require('bee-alert/build/Alert.css');
import "./index.less";

class Alert extends Component {
    render() { 
        return <OriginAlert 
            {...this.props} 			
        />;
    }
}
 
export default Alert;
